export const BREAKPOINTS = {
  tiny: 480,
  tablet: 768,
  desktop: 1024,
  widescreen: 1200,
  fullhd: 1680,
};

export const BBC_PROMO_CODE = 'bbc';

export const FNF_PROMO_CODE = 'fnf';

export const GLIMP_PROMO_CODE = 'glimp';

export const COMPASS_PROMO_CODE = 'compass';

export const MOBILE_COMPARE_PROMO_CODE = 'mobilecompare';

export const MOBILE_GLIMP_PROMO_CODE = 'glimp';

export const MOBILE_DEAL_PROMO_CODE = 'mobiledeal';

export const CHILDFUND_PROMO_CODE = 'childfund';

export const MOBILE_ABANDONED_CART_PROMO_CODE = 'MOB50OFF';

export const MOBILE_LONG_WEEKEND_PROMO_CODE = 'mobilelongweekend';
